

























import { Component, Prop, Mixins } from "vue-property-decorator";
import VAccordion from "@/components/VAccordion.vue";
import ModelParserMixin from "@/mixins/ModelParser";
import VSelect from "@/components/VSelect.vue";
import { currentScoutingStore, currentUserStore } from "@/store/typed";
import ScoutingAreaItem from "@/components/ScoutingArea/Item.vue";
import { AnalysisState } from "@/models/Scouting";
import { ScoutingArea } from "@/models";

@Component({
  components: {
    VAccordion,
    ScoutingAreaItem,
    VSelect,
  },
})
export default class AreaCollapsableList extends Mixins(ModelParserMixin) {
  @Prop({ default: false }) readonly showLegend!: boolean;
  @Prop({ default: false }) readonly isOpened!: boolean;

  async load() {}

  get scoutingAreas() {
    return currentScoutingStore.scoutingAnalysis?.scouting.scoutingAreas || [];
  }

  onStatusChanged(closed: boolean) {
    this.$emit("status", closed);
  }

  get areeCount() {
    return this.scoutingAreas.length;
  }

  async onItemClicked(item: ScoutingArea) {
    await currentScoutingStore.clearSelection();
    await currentScoutingStore.changeScoutingAnalysisState(AnalysisState.Area);
    await currentScoutingStore.changeScoutingAnalysisCurrentArea(item);
  }
}
